import { render } from "./CookiesView.vue?vue&type=template&id=45151dff&lang=pug"
import script from "./CookiesView.vue?vue&type=script&lang=js"
export * from "./CookiesView.vue?vue&type=script&lang=js"

import "./CookiesView.vue?vue&type=style&index=0&id=45151dff&lang=scss&global=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__